import { dataPhoneCallSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPhoneCallSolid = /*#__PURE__*/createIcon(dataPhoneCallSolid)
export default IconPhoneCallSolid
